/* eslint-disable no-nested-ternary, consistent-return, class-methods-use-this, vars-on-top, no-unneeded-ternary, no-param-reassign, react/no-unescaped-entities, react/no-unknown-property, prefer-const, react/no-did-update-set-state */

import Collapse from '@material-ui/core/Collapse'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import Settings from '@material-ui/icons/Settings'
import cn from 'classnames'
import { cloneDeep, get, groupBy, isEmpty, isFunction, map, mapKeys, times } from 'lodash'
import React, { PureComponent } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import AlertMessageComponent from '../AlertMessage'
import { ConditionalWrapper } from '../ConditionalWrapper'
import ExportTableData from '../ExportTableData'
import Icon from '../Icon'
import IconButton from '../IconButton'
import LabelWrapper from '../LabelWrapper'
import { Modal } from '../Modal'
import Pagination from '../Pagination'
import PagingSetting from '../PagingSetting'
import ResponsiveTable from '../ResponsiveTable'
import SearchInputBox from '../SearchInputBox'
import Skeleton from '../Skeleton'
import StatusLabel from '../StatusLabel'
import TableSettingModal from '../TableSettingModal'
import { Text } from '../Typography'
import SelectTools from './SelectTools'
import styles from './styles'
import TableHeader from './TableHeader'
import TablePreview from './TablePreview'
import TableRow from './TableRow'
import TableRowHeader from './TableRowHeader'

// Local replacement for MUI v4's isWidthDown (removed in v5).
// Returns true when the current `width` breakpoint is at or below `breakpoint`.
const breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl']
const isWidthDown = (breakpoint, width, inclusive = true) => {
  const bpIndex = breakpointKeys.indexOf(breakpoint)
  const widthIndex = breakpointKeys.indexOf(width)
  return inclusive ? widthIndex <= bpIndex : widthIndex < bpIndex
}

class Table extends PureComponent {
  constructor(props) {
    super(props)
    const { headers, data } = props
    this.state = {
      showSettingsModal: false,
      showFilters: false,
      headers,
      currentExpandedRowOpen: undefined, // that state work while expandedRowRenderSetting.multiple = false
      data,
      visibleWidth: 0,
      totalWidth: 0,
      scrollPosition: 0,
    }
  }

  scrollRef = React.createRef()

  componentDidMount() {
    this.scrollRef.current.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    this.scrollRef.current.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    this.setState({
      scrollPosition: this.scrollRef.current.scrollLeft,
    })
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  componentDidUpdate(prevProps, prevState) {
    /* eslint-disable-next-line no-unused-vars */
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { visibleWidth, totalWidth } = this.state
    this.setState({
      visibleWidth: this.scrollRef.current.offsetWidth,
      totalWidth: this.scrollRef.current.scrollWidth,
    })
  }

  componentWillReceiveProps(nextProps) {
    const { headers, data } = this.props
    if (headers !== nextProps.headers) {
      this.setState({
        headers: nextProps.headers,
      })
    }
    if (data !== nextProps.data) {
      this.setState({
        data: nextProps.data,
      })
    }
  }

  onSaveSettings = headers => {
    const { showSettingsModal, showFilters } = this.state
    this.setState({
      showSettingsModal: !showSettingsModal,
      showFilters: !showFilters,
      headers,
    })
  }

  handleChangeCurrentExpandedRowOpen = currentExpandedRowOpen =>
    this.setState({
      currentExpandedRowOpen,
    })

  onSearchText = value => {
    const { onSearch } = this.props
    return onSearch({ target: { value } })
  }

  toggleFilters = () => {
    const { showFilters } = this.state
    this.setState({ showFilters: !showFilters })
  }

  toggleModal = () => {
    const { showSettingsModal } = this.state
    this.setState({ showSettingsModal: !showSettingsModal })
  }

  groupRows = (data, groupName) => {
    if (groupName) {
      return groupBy(data, groupName)
    }
    return data
  }

  onDragStart = item => {
    const { onDragStart, tableGroupBy } = this.props
    if (isFunction(onDragStart)) {
      onDragStart()
    }
    const current = get(this.listItems, `[${item.source.index}]`) || {}
    if (current.isGroupHeader || current.isRowHeader) {
      this.setState({ draggingHead: current[tableGroupBy] })
    }
  }

  reorderRows = data => {
    this.headerMap = {}
    const headers = []
    const children = {}
    const ordered = []
    map(data, d => {
      if (d.isRowHeader || !d.belongsToHeader) {
        this.headerMap[d.id] = d.heading
        return headers.push(d)
      }

      if (children[d.belongsToHeader]) {
        children[d.belongsToHeader].push(d)
      } else {
        children[d.belongsToHeader] = [d]
      }
    })
    map(headers, h => {
      if (h.isRowHeader && children[h.id]) {
        h.length = children[h.id].length
      }
      ordered.push(h)

      if (h.isRowHeader && children[h.id]) {
        map(children[h.id], c => ordered.push(c))
      }
    })
    return ordered
  }

  onDropLocked = message => {
    const dialog = {
      title: 'Product Group Locked',
      message,
      onSubmit: () => {
        this.setState({ dialog: { isOpen: false } })
      },
      okText: 'Ok',
      isHideCancel: true,
      isOpen: true,
    }
    this.setState({ dialog })
  }

  onNonGroupDragEnd = (items, current, previous = {}, next = {}) => {
    const { onRowDragEnd, onItemsReordered } = this.props
    const currentType = current.isRowHeader ? 'Product Group' : 'Product'
    // drop to the position before locked group/item
    if (isEmpty(previous) && next.isLocked) {
      const message = <>{currentType} cannot be dropped above locked rows.</>
      this.onDropLocked(message)
      return
    }
    // previous group id
    const previousGroup = previous.isRowHeader
      ? previous.id
      : previous.belongsToHeader
        ? previous.belongsToHeader
        : undefined
    // next group id
    const nextGroup = next.isRowHeader ? next.id : next.belongsToHeader ? next.belongsToHeader : undefined
    // dropped position between items that belong to different group or non group
    const isOnBoundary = previousGroup && previousGroup !== nextGroup

    // dropped to locked group
    const prevGroup = items.find(i => i.id === previousGroup) || {}
    if (prevGroup.isLocked && !isOnBoundary) {
      const message = (
        <>
          Product Group <strong>{prevGroup.heading}</strong> isLocked.
        </>
      )
      this.onDropLocked(message)
      return
    }

    // drop between locked groups/items
    if (previous.isLocked && next.isLocked) {
      const message = <>{currentType} cannot be dropped between locked rows.</>
      this.onDropLocked(message)
      return
    }

    if (isFunction(onRowDragEnd)) {
      onRowDragEnd()
    }

    const cb = isFunction(onItemsReordered) ? onItemsReordered : () => {}

    // dragged is row header, reorder list only
    if (current.isRowHeader) {
      const final = this.reorderRows(items)
      return cb(final)
    }

    // no dependency
    if (!items.some(i => i.isRowHeader)) {
      return cb(items)
    }

    // dragged is normal row, check dependency
    current.isDragged = true

    // drop under locked groups
    if (prevGroup.isLocked && isOnBoundary) {
      delete current.belongsToHeader
      return cb(items)
    }

    // drop into product group
    if (!isOnBoundary && previousGroup) {
      current.belongsToHeader = previousGroup
      return cb(items)
    }

    // drop outside product group
    if (!isOnBoundary && !previousGroup) {
      delete current.belongsToHeader
      return cb(items)
    }

    // if on the boundary of group, let user choose where to drop
    const dialog = {
      title: 'Move Product to...',
      message: (
        <>
          Please select <strong>"Product Group"</strong> to move this Product into the Product Group or select{' '}
          <strong>"Below"</strong> if you wish to move the Product below the {this.headerMap[previousGroup]}?
        </>
      ),
      onSubmit: () => {
        current.belongsToHeader = previousGroup
        this.setState({ dialog: { isOpen: false } })
        return cb(items)
      },
      onCancel: () => {
        delete current.belongsToHeader
        this.setState({ dialog: { isOpen: false } })
        return cb(items)
      },
      isOpen: true,
    }
    this.setState({ dialog })
  }

  onRowDragEnd = result => {
    const { tableGroupBy, onGroupReordered, onRowDragEnd, onHeaderDragEnd, onItemsReordered } = this.props

    this.setState({ draggingHead: undefined })

    // dropped outside the list
    if (!result.destination) {
      return
    }
    // reorder
    const items = cloneDeep(this.listItems)

    const [removed] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, removed)

    const current = items[result.destination.index]
    const previous = result.destination.index === 0 ? undefined : items[result.destination.index - 1]
    const next = result.destination.index === items.length - 1 ? undefined : items[result.destination.index + 1]
    if (!tableGroupBy) {
      return this.onNonGroupDragEnd(items, current, previous, next)
    }

    // a data row cannot be the first of list
    if (!current.isGroupHeader && !!previous) {
      if (isFunction(onRowDragEnd)) {
        onRowDragEnd()
      }
      current[tableGroupBy] = previous[tableGroupBy]
      current.isDragged = true
      return isFunction(onItemsReordered) ? onItemsReordered(items.filter(i => !i.isGroupHeader)) : undefined
    }

    if (current.isGroupHeader) {
      if (isFunction(onHeaderDragEnd)) {
        onHeaderDragEnd()
      }
      // biome-ignore lint/performance/noAccumulatingSpread: TODO
      const newGroupOrder = items.reduce((a, g) => [...a, ...(g.isGroupHeader ? [g[tableGroupBy]] : [])], [])
      return isFunction(onGroupReordered) ? onGroupReordered(newGroupOrder) : undefined
    }
  }

  renderRow = (row, i) => {
    const {
      classes,
      ExpandedRowRender,
      expandedRowRenderSetting,
      noBorderCell,
      expandedRowColspan,
      rowDraggable,
      tableGroupBy,
    } = this.props
    const { headers, currentExpandedRowOpen, draggingHead } = this.state

    // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
    mapKeys(row, (value, key) => {
      if (key === 'relatedProductGroup') {
        return 'belongsToHeader'
      }
      return key
    })

    const rowProps = {
      handleChangeCurrentExpandedRowOpen: this.handleChangeCurrentExpandedRowOpen,
      more: currentExpandedRowOpen === i,
      key: i,
      index: row.index,
      data: row,
      rowKey: i,
      rowStatus: row.rowStatus,
      headers: (headers || []).filter(h => !h.isCompletelyHidden),
      ExpandedRowRender,
      expandedRowRenderSetting,
      noBorderCell,
      classNameDrag: draggingHead && draggingHead === row[tableGroupBy] ? classes.rowHidden : '',
    }

    const colSpan = headers.length + 1

    if (!rowDraggable) {
      return (
        <>
          <TableRow expandedRowColspan={expandedRowColspan || colSpan} {...rowProps} />
          {row.bottomRow && (
            <tr>
              <td colSpan={10} className={classes.bottomRow}>
                {row.bottomRow}
              </td>
            </tr>
          )}
        </>
      )
    }
    return (
      <Draggable key={i} draggableId={`row_${i}`} index={i}>
        {(provided, snapshot) => {
          const dragProps = {
            ref: provided.innerRef,
            ...provided.dragHandleProps,
            ...provided.draggableProps,
          }
          return (
            <>
              <TableRow isDraggable isDragging={snapshot.isDragging} {...rowProps} dragProps={dragProps} />
              {row.bottomRow && (
                <tr dragProps={dragProps}>
                  <td colSpan={10} className={classes.bottomRow}>
                    {row.bottomRow}
                  </td>
                </tr>
              )}
            </>
          )
        }}
      </Draggable>
    )
  }

  renderRowHeader = (row, index) => {
    const {
      tableGroupDescription,
      tableGroupHeaderSize,
      tableGroupActions,
      tableGroupRules,
      headerDraggable,
      rowDraggable,
    } = this.props

    const { headers, tableGroupCount } = this.state

    const rowHeaderProps = {
      row,
      cols: headers.length,
      count: row.children ? row.children.length : row.length,
      heading: row.heading,
      tableGroupDescription,
      tableGroupHeaderSize,
      tableGroupRules,
      tableGroupCount,
      tableGroupActions,
    }

    if (!rowDraggable && !headerDraggable) {
      return <TableRowHeader {...rowHeaderProps} />
    }
    return (
      <Draggable
        key={rowHeaderProps.heading}
        draggableId={`header_${rowHeaderProps.heading}`}
        index={index}
        isDragDisabled={!headerDraggable}
      >
        {(provided, snapshot) => {
          return (
            <TableRowHeader
              isDraggable={headerDraggable}
              provided={provided}
              isDragging={snapshot.isDragging}
              {...rowHeaderProps}
            />
          )
        }}
      </Draggable>
    )
  }

  renderBoth = () => {
    const { data } = this.state
    const ordered = this.reorderRows(data)
    this.listItems = ordered
    const rows = map(ordered, (o, i) => (o.isRowHeader ? this.renderRowHeader(o, i) : this.renderRow(o, i)))
    return rows
  }

  renderTableGroup = () => {
    const { tableGroupBy, tableGroupOrder } = this.props
    const { data, headings } = this.state
    const grouped = groupBy(data, tableGroupBy)
    const tableData = []
    if (tableGroupOrder && tableGroupOrder.length > 0) {
      tableGroupOrder.forEach(heading => {
        tableData.push(grouped[heading])
      })
    }

    if (data.length < 1) {
      return null
    }
    this.listItems = []
    map(tableData, group => {
      const heading = group && group.length > 0 ? group[0][tableGroupBy] : 'Undefined'
      this.listItems.push({
        heading,
        isGroupHeader: true,
        length: group ? group.length : 0,
        [tableGroupBy]: heading,
      })
      this.listItems = this.listItems.concat(group)
    })

    return map(headings || this.listItems || {}, (row, i) =>
      row.isGroupHeader ? this.renderRowHeader(row, i) : this.renderRow(row, i)
    )
  }

  render() {
    const {
      badgeVariant,
      classes,
      hideTableSetting,
      hideTableTop,
      hideTablePaging,
      hideTableSearch,
      leftButton,
      filterComponents,
      filterCount,
      extraFilters,
      disableReArrange,
      className,
      wrapperClassName,
      onSort,
      onChangePageSize,
      onChangePage,
      currentPage,
      total,
      totalSelected,
      pageSize,
      searchPlaceholder,
      noDataMessage,
      itemName,
      isNodeEndpoint,
      token,
      exportDataUrl,
      exportDataPath,
      showExportData,
      exportFileName,
      ExpandedRowRender,
      expandedRowRenderSetting,
      fullWidthFilters,
      noPadding,
      delay,
      loading,
      searchText,
      smallPagination,
      actionColumn,
      isSearchTable,
      baseURL,
      xApiKey,
      hideSizePerPage,
      hideShowingRows,
      hideTableHeader,
      noBorderCell,
      marginBottom,
      visiblePages,
      selectTools,
      handleSelectAll,
      handleSelectNone,
      hideNoDataMessage,
      expandedRowColspan,
      tableKey,
      showListOnMobile,
      rowId,
      width,
      tableGroupBy,
      tableGroupDescription,
      tableGroupHeaderSize,
      tableGroupCount,
      tableGroupActions,
      headerDraggable,
      rowDraggable,
      messageData,
      showSubtabs,
      SubtabComponent,
      showTotalRecords,
      showSelectedCount,
      selectedCount,
      customCountText,
      orgId,
      contactId,
      eventId,
      showTablePreview = false,
      config,
      ...rest
    } = this.props

    const {
      showSettingsModal,
      showFilters,
      headers,
      data,
      dialog = {},
      visibleWidth,
      totalWidth,
      scrollPosition,
    } = this.state

    const {
      show: msgShow,
      variant: msgVariant,
      message: msgText,
      marginTop: msgMarginTop,
      marginBottom: msgMarginBottom,
      className: msgClassName,
      size: msgSize,
    } = messageData
    const hasFilters = filterComponents && filterComponents.filter(f => !!f).length > 0
    const hasExtraFilters = extraFilters && extraFilters.filter(f => !!f).length > 0

    const visibleColumns = headers.filter(h => !h.isHiddenColumn)

    return (
      <div className={wrapperClassName}>
        {!hideTableTop && (
          <>
            {dialog.isOpen && (
              <Modal
                isShowBottomBar
                isShowSaveButton
                isOpen
                maxWidth="sm"
                fullWidth
                label={dialog.title}
                isSubmitWithOutClose
                okText={dialog.okText || 'Product Group'}
                cancelText="Below"
                handleModalSubmit={dialog.onSubmit}
                handleModalClose={dialog.onCancel}
                isHideCancel={dialog.isHideCancel}
              >
                <div className={classes.productModal}>{dialog.message}</div>
              </Modal>
            )}
            <div
              className={cn(
                classes.topTable,
                {
                  isSearchTable,
                },
                filterCount >= 5 && 'has-extra-filters'
              )}
            >
              {!isWidthDown('sm', width) ? (
                <>
                  {!isSearchTable && (
                    <LabelWrapper notWrapper withBorder>
                      <div className={classes.tableButtons}>{leftButton}</div>
                    </LabelWrapper>
                  )}
                  <div
                    className={cn(
                      {
                        'full-width-search': isSearchTable,
                      },
                      classes.searchBox,
                      classes.tableTools
                    )}
                  >
                    {!isSearchTable && hasFilters && (
                      <div className={classes.filter}>
                        <div>{filterComponents}</div>
                      </div>
                    )}
                    {!hideTableSearch && (
                      <SearchInputBox
                        delay={delay}
                        fullWidth={isSearchTable}
                        icon
                        placeholder={searchPlaceholder}
                        onChange={this.onSearchText}
                        searchText={searchText}
                        id={tableKey}
                        withBorder
                      />
                    )}
                    {!hideTableSetting && (
                      <IconButton
                        className={classes.tableConfig}
                        icon={<Settings />}
                        onClick={this.toggleModal}
                        aria-label="Settings"
                      />
                    )}
                    {showExportData && (
                      // biome-ignore lint/complexity/noUselessFragments: TODO
                      <>
                        {total > 0 && (
                          <ExportTableData
                            isNodeEndpoint={isNodeEndpoint}
                            token={token}
                            exportFileName={exportFileName}
                            exportDataUrl={exportDataUrl}
                            exportDataPath={exportDataPath}
                            headers={headers}
                            baseURL={baseURL}
                            xApiKey={xApiKey}
                            orgId={orgId}
                            contactId={contactId}
                            eventNumber={eventId}
                            config={config}
                          />
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : (
                <div className={classes.mobileHeader}>
                  <div className={classes.mobileTools}>
                    {!isSearchTable && (
                      <LabelWrapper notWrapper withBorder>
                        <div
                          className={cn(classes.tableButtons, {
                            smallView: isWidthDown('xs', width),
                          })}
                        >
                          {leftButton}
                        </div>
                      </LabelWrapper>
                    )}
                    <div className={classes.mobileIcons}>
                      {hasFilters && (
                        <IconButton
                          className={cn({
                            'filters-active': showFilters,
                          })}
                          icon={<Icon iconName="adjust" iconSize={24} viewBox="0 0 24 24" />}
                          onClick={this.toggleFilters}
                          aria-label="Filters"
                        />
                      )}
                      {!hideTableSetting && (
                        <IconButton icon={<Settings />} onClick={this.toggleModal} aria-label="Settings" />
                      )}
                      {showExportData && (
                        // biome-ignore lint/complexity/noUselessFragments: TODO
                        <>
                          {total > 0 && (
                            <ExportTableData
                              isNodeEndpoint={isNodeEndpoint}
                              token={token}
                              exportFileName={exportFileName}
                              exportDataUrl={exportDataUrl}
                              exportDataPath={exportDataPath}
                              headers={headers}
                              baseURL={baseURL}
                              xApiKey={xApiKey}
                              orgId={orgId}
                              contactId={contactId}
                              eventNumber={eventId}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {!isSearchTable && (hasFilters || hasExtraFilters) && (
                    <Collapse
                      in={showFilters}
                      classes={{
                        container: classes.filterContainer,
                        wrapperInner: classes.filterWrapper,
                      }}
                    >
                      <div className={classes.topArrow} />
                      <div className={classes.mobileFilters}>
                        {filterComponents}
                        {extraFilters}
                      </div>
                    </Collapse>
                  )}
                  {!hideTableSearch && (
                    <div className={classes.mobileSearch}>
                      <SearchInputBox
                        delay={delay}
                        fullWidth
                        icon
                        placeholder={searchPlaceholder}
                        onChange={this.onSearchText}
                        searchText={searchText}
                        id={tableKey}
                        withBorder
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            {showSubtabs && SubtabComponent}
            {!isWidthDown('sm', width) && hasExtraFilters && (
              <div className={classes.extraFiltersWrap}>{extraFilters}</div>
            )}
            {selectTools && (
              <SelectTools
                badgeVariant={badgeVariant}
                handleSelectAll={handleSelectAll}
                handleSelectNone={handleSelectNone}
                totalSelected={totalSelected}
              />
            )}
          </>
        )}
        {fullWidthFilters && <Grid className={classes.fullWidthFilters}>{fullWidthFilters}</Grid>}

        <ConditionalWrapper
          condition={rowDraggable || headerDraggable}
          wrapper={children => (
            <DragDropContext onDragEnd={this.onRowDragEnd} onDragStart={this.onDragStart}>
              {children}
            </DragDropContext>
          )}
        >
          {messageData && (
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <>
              <AlertMessageComponent
                variant={msgVariant || 'info'}
                className={msgClassName || className}
                show={msgShow || false}
                size={msgSize || 'md'}
                marginBottom={msgMarginBottom || null}
                marginTop={msgMarginTop || null}
              >
                {msgText}
              </AlertMessageComponent>
            </>
          )}
          {showSelectedCount && (
            <div className={classes.selectedCount}>
              <StatusLabel
                variant="success"
                label={`${selectedCount || 0} ${customCountText ? customCountText : 'Selected'}`}
              />
            </div>
          )}
          {showListOnMobile && isWidthDown('xs', width) ? (
            <div ref={this.scrollRef}>
              <ResponsiveTable
                data={data}
                headers={headers}
                tableGroupBy={tableGroupBy}
                tableGroupDescription={tableGroupDescription}
                tableGroupHeaderSize={tableGroupHeaderSize}
                tableGroupCount={tableGroupCount}
                tableGroupActions={tableGroupActions}
                excludePrimaryFromDetails
                rowId={rowId}
                isMobile
                loading={loading}
                pageSize={pageSize}
                marginBottom={marginBottom}
              />
            </div>
          ) : (
            <div
              ref={this.scrollRef}
              className={cn(classes.tableWrap, {
                'row-actions': actionColumn,
                'no-padding': noPadding,
                'no-scroll': visibleWidth === totalWidth || scrollPosition + visibleWidth === totalWidth,
              })}
            >
              <table className={cn(classes.table, className)} {...rest}>
                {!hideTableHeader && (
                  <TableHeader
                    headers={(headers || []).filter(h => !h.isCompletelyHidden)}
                    onSortChange={onSort}
                    ExpandedRowRender={ExpandedRowRender}
                    data={data}
                    loading={loading}
                    indent={rowDraggable ? 1 : 0}
                  />
                )}
                <ConditionalWrapper
                  condition={rowDraggable || headerDraggable}
                  wrapper={children => (
                    <Droppable droppableId="droppable">
                      {provided => (
                        <tbody ref={provided.innerRef}>
                          {children}
                          {provided.placeholder}
                        </tbody>
                      )}
                    </Droppable>
                  )}
                  otherwise={children => <tbody>{children}</tbody>}
                >
                  {/** biome-ignore lint/complexity/noUselessFragments: TODO */}
                  <>
                    {loading &&
                      times(pageSize, i => (
                        <tr key={i} className={classes.loadingRow}>
                          {times(
                            (headers || []).filter(h => !h.isHiddenColumn).filter(h => !h.isCompletelyHidden).length,
                            x => (
                              <td key={x} className={classes.loadingCell}>
                                <Skeleton width="100%" height={32} className={classes.skeleton} />
                              </td>
                            )
                          )}
                        </tr>
                      ))}
                    {!loading && <>{!tableGroupBy ? this.renderBoth() : this.renderTableGroup()}</>}
                  </>
                </ConditionalWrapper>
              </table>
              {!loading && showTablePreview && (
                <TablePreview
                  visibleColumns={visibleColumns.length}
                  visibleWidth={visibleWidth}
                  totalWidth={totalWidth}
                  scrollPosition={scrollPosition}
                />
              )}
              {!loading && isEmpty(data) && !hideNoDataMessage && (
                <div className={classes.noData}>
                  <Text component="h2">{noDataMessage}</Text>
                </div>
              )}
            </div>
          )}
        </ConditionalWrapper>
        <div className={classes.pagingWrapper}>
          {!hideTablePaging && (
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <>
              {total > 0 && [
                hideSizePerPage && hideShowingRows ? null : (
                  // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                  <div
                    className={cn('paging-setting', classes.pagingItem, {
                      smaller: smallPagination && !showExportData,
                    })}
                  >
                    <PagingSetting
                      exportFileName={exportFileName}
                      showExportData={showExportData}
                      exportDataUrl={exportDataUrl}
                      exportDataPath={exportDataPath}
                      headers={headers}
                      onChangePageSize={onChangePageSize}
                      currentPage={currentPage}
                      total={total}
                      itemName={itemName}
                      options={total && showTotalRecords ? [5, 10, 25, 50, total] : [5, 10, 25, 50]}
                      itemPerPage={pageSize}
                      totalSelected={totalSelected}
                      smallPagination={smallPagination}
                      hideSizePerPage={hideSizePerPage}
                      hideShowingRows={hideShowingRows}
                    />
                  </div>
                ),
                // eslint-disable-next-line react/jsx-key
                // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                <div className={classes.pagingItem}>
                  <Pagination
                    numPage={Math.ceil(total / pageSize)}
                    activePage={currentPage}
                    setPage={onChangePage}
                    smallPagination={smallPagination}
                    visiblePage={visiblePages}
                    showExportData={showExportData}
                    hideSizePerPage={hideSizePerPage}
                    hideShowingRows={hideShowingRows}
                  />
                </div>,
              ]}
            </>
          )}
          <div className={cn(classes.pagingItem, 'align-right')} />
        </div>
        {!hideTableSetting && (
          <TableSettingModal
            disableReArrange={disableReArrange}
            onSave={this.onSaveSettings}
            headers={headers.filter(h => !h.isCompletelyHidden)}
            toggleModal={this.toggleModal}
            isOpenModal={showSettingsModal}
          />
        )}
      </div>
    )
  }
}

Table.defaultProps = {
  accordian: false,
  actionColumn: false,
  badgeVariant: 'success',
  className: '',
  currentPage: 1,
  data: [],
  delay: 2000,
  disableReArrange: false,
  expandedChildren: {},
  expandedRowRenderSetting: {
    multiple: true,
    refresh: false,
  },
  extraFilters: null,
  filterComponents: null,
  headers: [],
  hideNoDataMessage: false,
  hideShowingRows: false,
  hideSizePerPage: false,
  hideTableHeader: false,
  hideTablePaging: false,
  hideTableSearch: false,
  hideTableSetting: false,
  hideTableTop: false,
  isSearchTable: false,
  itemName: 'items',
  leftButton: null,
  loading: false,
  marginBottom: 8,
  noBorderCell: false,
  noDataMessage: 'No Data',
  onSort: f => f,
  pageSize: 25,
  searchPlaceholder: 'Type to search',
  searchText: '',
  showExportData: false,
  showListOnMobile: false,
  smallPagination: false,
  visiblePages: 5,
  tableGroupOrder: [],
  isNodeEndpoint: false,
  token: '',
  messageData: {},
}

const TableComponent = withStyles(styles)(Table)
const TableWithWidth = withWidth()(TableComponent)
TableWithWidth.displayName = 'Table'
export default TableWithWidth
